import buildDrillDown from 'buildDrillDown';
import isPaceMatrix from 'types/visTypeCheckers/isPaceMatrix';
import isRankingMatrix from 'types/visTypeCheckers/isRankingMatrix';
import isSingleMetricDateMatrix from 'types/visTypeCheckers/isSingleMetricDateMatrix';
import isV5ChartDef from 'types/visTypeCheckers/isV5ChartDef';

import toAutoInterval, { toInterval } from '../../toAutoInterval';

// The filter a click on a matrix grouping cell stands for: the row's member on
// the chart's dimension, or its date bucket for a trend. Pure so the popup path
// (usePopup) and the Insights "explain this value" path build the same filter.
const buildDrillDownFromInteraction = ({
  chartDef,
  term,
  rawDate,
  dateScope,
  autoIntervalResponse,
}: {
  chartDef?: VisualisationDefinition;
  term: string;
  rawDate?: string;
  dateScope: DateRangeInput;
  autoIntervalResponse?: string;
}): FixedFilter | undefined => {
  if (
    term &&
    isV5ChartDef(chartDef) &&
    chartDef.dimensionA &&
    chartDef.dimensionA.fieldType &&
    (chartDef.dimensionA.fieldType === 'text' ||
      chartDef.dimensionA.fieldType === 'date')
  ) {
    const drillField = (() => {
      if (chartDef.dimensionA) {
        if (chartDef.dimensionA.field === 'date') {
          if (
            chartDef.trendByCalendarInterval === 'auto' &&
            autoIntervalResponse
          ) {
            return toInterval(autoIntervalResponse) || 'day';
          }
          return chartDef.trendByCalendarInterval || 'day';
        }
        return chartDef.dimensionA.field;
      }
      return '';
    })();

    if (rawDate && chartDef.dimensionA.fieldType === 'date') {
      return buildDrillDown(
        drillField,
        chartDef.dimensionA.fieldType === 'date'
          ? 'dateText'
          : chartDef.dimensionA.fieldType,
        rawDate,
        chartDef,
        dateScope,
        autoIntervalResponse ? toAutoInterval(autoIntervalResponse) : undefined,
      );
    } else {
      return buildDrillDown(
        drillField,
        chartDef.dimensionA.fieldType,
        term,
        chartDef,
        dateScope,
      );
    }
  }

  if (
    term &&
    chartDef &&
    (isSingleMetricDateMatrix(chartDef) ||
      isRankingMatrix(chartDef) ||
      isPaceMatrix(chartDef))
  ) {
    return buildDrillDown(
      chartDef.groupByField,
      'text',
      term,
      chartDef,
      dateScope,
    );
  }

  return undefined;
};

export default buildDrillDownFromInteraction;
